var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronRightGray16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "18px",
    viewBox: "0 0 11 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "28630118-1E25-4868-AF3B-18F34FA77A4B_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Rollivahetus",
    transform: "translate(-457.000000, -257.000000)",
    stroke: "#C1C1C1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaart-/-Master-Copy-12",
    transform: "translate(34.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Icon_Chevron-Right_Gray-16px",
    transform: "translate(428.000000, 40.000000) rotate(-90.000000) translate(-428.000000, -40.000000) ",
    points: "420 36 428 44 436 36"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRightGray16Px);
export default __webpack_public_path__ + "static/media/Icon_Chevron-Right_Gray-16px.6e662395cc7a196db2e496f7d92beab0.svg";
export { ForwardRef as ReactComponent };